module.exports = __webpack_public_path__ + "img/SC-PROOF-3799.6db51a6a.png";